export default [
  [`Порода`, `Размер`, `Длина спины`, `Обхват шеи`, `Обхват груди`],
  [`Мелкие породы`],
  [
    `Миниатюрный йокширский терьер, чихуахуа, миниатюрный пинчер, той терьер, щенки др. мелких пород`,
    `4XS`,
    `24`,
    `18-20`,
    `28-33`
  ],
  [
    `Йокширский терьер, мальтезе, померанский шпиц, ши-тцу, тойпудель, карликовый пудель`,
    `3XS`,
    `26`,
    `23-25`,
    `35-40`
  ],
  [
    `Мальтезе, китайская хохлатая, пудель, шнауцер, японский хин, мопс`,
    `2XS`,
    `28`,
    `26-28`,
    `40-45`
  ],
  [
    `Кокер-спаниель, фокстерьер, скотчтерьер, такса, ши-тцу, пекинес`,
    `XS`,
    `32`,
    `28-30`,
    `48-50`
  ],
  [
    `Бишон фризе, керри-блю-терьер, пудель средний, левретка, миттельшнауцер`,
    `S`,
    `34`,
    `33-39`,
    `50-55`
  ],
  [`Бигль, фокстерьер, миттельшнауцер`, `M`, `38`, `39-43`,`58-60`],
  [`Крупные породы`],
  [
    `Бультерьер, бигль, английский бульдог, стаффордширский терьер, русский спаниель, шарпей, далматин, бассет-хаунд`,
    `L`,
    `40-45`,
    `40-46`,
    `60-65`
  ],
  [
    `Лабрадор, хаски, боксер, питбуль, эрдельтерьер, ротвейлер`,
    `XL`,
    `50-55`,
    `46-48`,
    `70-78`
  ],
  [
    `Русский черный терьер, лабрадор, американский бульдог, сеттер, доберман, риджбек, мастино, немецкая овчарка, ризеншнауцер`,
    `2XL`,
    `60-65`,
    `50-56`,
    `82-90`
  ],
  [`Сенбернар, мастиф, дог`, `3XL`, `70-75`, `60-70`, `95-110`]
];
